import React, { useCallback, useState, useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import Progress from '../Form/Progress'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { useParams } from 'react-router-dom'
import CreateSubsequentDeliveryModal from './CreateSubsequentDeliveryModal'
import ArticleScan from '../Form/ArticleScan'
import { BiBarcodeReader } from 'react-icons/bi'

const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`
const StyledCancelButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const StyledScanButton = styled(Button)`
  width: 100%;
  max-width: 250px;
`
const StoreReceiptSidebar = () => {
  const {
    submitEditReceipt,
    submitStoreReceipt,
    errorsOccurredOnSubmit,
    formDataHasChanged,
    resetFormData,
    setSuccessSubmit,
    successSubmit,
    positions, storingResult, subsequentDeliveryResult,
    loadedReceiptData, addScannedArticle
  } = useLocalReceiptDataState()
  const { receiptId } = useParams()
  const [isLoading, setIsLoading] = useState(false)
  const [isSaving, setIsSaving,] = useState(false)
  const [openCreateSubsequentDeliveryModal, setOpenCreateSubsequentDeliveryModal] = useState(false)
  const [openScanModal, setOpenScanModal,] = useState(false)

  const handleSubmit = useCallback(async e => {
    setSuccessSubmit(false)
    setIsLoading(true)
    formDataHasChanged && await submitEditReceipt()
    setIsLoading(false)
  }, [formDataHasChanged, setSuccessSubmit, submitEditReceipt])

  const handleSubmitIsStored = useCallback(async e => {
    setSuccessSubmit(false)
    setIsSaving(true)
    !formDataHasChanged && await submitStoreReceipt()
    setIsSaving(false)

    if (!!successSubmit) {
      /*setTimeout(() => {
        navigate("/localstorage/goodsreceipts")
      }, 1500)*/
    }
  }, [formDataHasChanged, successSubmit, setSuccessSubmit, submitStoreReceipt])
  const handleCloseCreateSubsequentDeliveryModal = async () => {
    setOpenCreateSubsequentDeliveryModal(false)
  }
  const handleClickCancel = () => {
    resetFormData();
  }
  useEffect(() => {
    let timeout = null
    if (!isLoading && !!successSubmit) {
      timeout = setTimeout(() => {
        setSuccessSubmit(false)
      }, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [isLoading, successSubmit, setSuccessSubmit])
  useEffect(() => {
    const { partialDeliveryOccured } = storingResult
    if (!!partialDeliveryOccured) {
      setOpenCreateSubsequentDeliveryModal(true)
    }
  }, [storingResult, setOpenCreateSubsequentDeliveryModal])

  const { t } = useTranslation()
  const { storageHeaderName } = subsequentDeliveryResult
  const { receiptTransactionNumber } = storingResult
  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('goodsReceiptOverlayProgress:headerStore')}</div>
      </header>
      <div className="content">
        <StyledScanButton className="mb-3"
          onClick={() => setOpenScanModal(true)}
          disabled={isLoading || !loadedReceiptData}
        >
          <BiBarcodeReader className='me-3' />
          {t('productsOverview:articleScan')}
        </StyledScanButton>
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={isLoading || !formDataHasChanged || !loadedReceiptData}
          buttonText={t('OverlayProgress:save')}
          loadingText={t('OverlayProgress:save')}
        />
        {(formDataHasChanged) && (
          <>
            <StyledCancelButton className="mb-3" variant="secondary" onClick={handleClickCancel}>{t('cancelButton')}</StyledCancelButton>
            <div className=" alert alert-info" >{t('EmployeeFormHealthData:dataChange')}</div>
          </>
        )}
        <Progress isStoring={true} />
        <div className="mb-5" />
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          disabled={isLoading || !!formDataHasChanged || isSaving || !loadedReceiptData || !positions.length}
          buttonText={t('goodsReceiptOverlayProgress:store')}
          loadingText={t('goodsReceiptOverlayProgress:store')}
          isLoading={isSaving}
          onClick={handleSubmitIsStored}
        />
        {(!isLoading && !isSaving && !!errorsOccurredOnSubmit) && (
          <Alert variant="danger">
            <Trans i18nKey='goodsReceiptOverlayProgress:danger' />
          </Alert>
        )}
        {(!isLoading && !isSaving && !!successSubmit) && (
          <Alert variant="success">
            {t('goodsReceiptOverlayProgress:updated')}
          </Alert>
        )}
        {!!storageHeaderName &&
          <Alert variant="success">
            {!!storageHeaderName && (`${t('createSubsequentDelivery:subsequentDeliveryResult')}${storageHeaderName}`)}
          </Alert>
        }
        {!!receiptTransactionNumber &&
          <Alert variant="success">
            {t('goodsReceiptOverlayProgress:storingResult')}
          </Alert>
        }
      </div>

      {openCreateSubsequentDeliveryModal ? <CreateSubsequentDeliveryModal receiptId={receiptId} handleClose={handleCloseCreateSubsequentDeliveryModal} /> : null}
      {openScanModal && (
        <ArticleScan
          handleClose={() => setOpenScanModal(false)}
          addScannedArticle={addScannedArticle}
        />
      )}
    </StyledContainer>
  )
}

export default StoreReceiptSidebar
